import {
  ChemicalCompoundsDTO,
  ChemicalCompoundsEquipmentDTO,
  KTLSGPStreamDTO,
  ChemicalCompoundRecord,
} from 'src/app/web-api-client';

export interface SGPFlaringState {
  data: ChemicalCompoundsDTO[];
  dataEquipment: ChemicalCompoundsEquipmentDTO[];
  streams: KTLSGPStreamDTO[];
  lims: ChemicalCompoundRecord[];
  result: any;
  isLoading: boolean;
  isLoadingSuccess: boolean;
  isLoadingFailure: boolean;
  localLoading: boolean;
}

export const SGP_FLARING_FEATURE_KEY = 'FD-SGP-FLARING';

export const sgpFlaringInitialState: SGPFlaringState = {
  data: [],
  dataEquipment: [],
  streams: [],
  lims: [],
  result: null,
  isLoading: false,
  isLoadingSuccess: false,
  isLoadingFailure: false,
  localLoading: false
};
